/*eslint-disable*/
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// actions
import { gatewayRequestAxios } from '../../services/interceptor'
import { GATEWAY_API_BULK_USER_UPLOAD_URL } from '../../constants/urls'

const initialState = {
    status: 'idle',
    error: null,
    transactionId: '',
    fileName: ''
}

export const bulkUserUpload = createAsyncThunk('uploadRequests/bulkUserUpload', async(bulkUsersJson) => {
    const response = await gatewayRequestAxios.post(GATEWAY_API_BULK_USER_UPLOAD_URL, bulkUsersJson)
    return response.data
})

export const uploadRequestsSlice = createSlice({
    name: 'uploadRequests',
    initialState,
    reducers: {},
    extraReducers(builder) {
      builder
        .addCase(bulkUserUpload.pending, (state) => {
          state.status = 'loading'
          state.error = undefined
        })
        .addCase(bulkUserUpload.fulfilled, (state, action) => {
          state.status = 'succeeded'
          state.error = undefined
          state.transactionId = action.payload.transactionId
          state.fileName = action.payload.uploaded_filename
          state.jobId = action.payload.jobId
        })
        .addCase(bulkUserUpload.rejected, (state, action) => {
          state.status = 'failed'
          state.error = action.error.message
        })
    }
  })

  export default uploadRequestsSlice.reducer;

